module.exports = __webpack_public_path__ + "img/bg2.0ea28c34.jpg";